import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronRight, FaThumbsUp, FaChevronLeft } from 'react-icons/fa';
import DonationModel from './DonationModel';

const EventsDetail = () => {
  const sliderData = [
    { id: 1, title: 'POOR PEOPLE NEED HELP', desc: 'Duis convallis turpis', raised: '$34,000', goal: '$50,489' },
    { id: 2, title: 'HELP HOMELESS CHILDREN', desc: 'Mauris vitae erat', raised: '$12,500', goal: '$20,000' },
    { id: 3, title: 'EMERGENCY FOOD FUND', desc: 'Donec sit amet nisl', raised: '$45,000', goal: '$60,000' },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModelOpen, setIsModelOpen] = useState(false);

  const categories = ['Poor', 'Children', 'Health Care', 'Food Crisis', 'Environment', 'Other Fund'];
  const helpOptions = ['Become Volunteer', 'Media', 'Donation Send', 'Helping Hand', 'Self Gift', 'Bank Transfer'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === sliderData.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const nextSlide = () => setCurrentSlide((prev) => (prev === sliderData.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentSlide((prev) => (prev === 0 ? sliderData.length - 1 : prev - 1));


  return (
    <div className="min-h-screen bg-white font-sans text-[#221f1f]">
      {/* 1. HERO SECTION */}
            <section 
              className="relative h-[45vh] flex items-center justify-center bg-cover bg-center"
              style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/gallery.jpg')` }}
            >
              <div className="text-center text-white">
                <motion.h1 
                  initial={{ y: 20, opacity: 0 }} 
                  animate={{ y: 0, opacity: 1 }} 
                  className="text-5xl md:text-6xl font-serif font-black uppercase tracking-tight"
                >
                  Events Details
                </motion.h1>
                <div className="h-1.5 w-20 bg-[#f9b50b] mx-auto mt-4"></div>
                <p className="mt-4 uppercase tracking-[0.3em] text-xs font-bold">
                  <Link to="/" className="hover:text-[#f9b50b] text-gray-300 transition-colors">Home</Link>
                  <span className="mx-2 text-gray-400">/</span>
                  <span className="text-white">Events</span>
                </p>
              </div>
            </section>
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
      {/* LEFT SIDE: EVENT CONTENT */}
<div className="lg:col-span-2 space-y-12">
  {/* 1. Date & Join Section (Clean & Minimal) */}
  <div className="flex flex-col sm:flex-row items-center justify-between border border-gray-100 p-8 bg-[#fcfcfc]">
    <div className="flex items-center gap-8">
      <div className="text-center">
        <span className="text-6xl font-serif font-bold text-[#221f1f] block leading-none">25</span>
        <div className="h-[2px] w-8 bg-[#f9b50b] mx-auto my-2"></div>
        <span className="text-[11px] font-bold uppercase tracking-widest text-gray-400">February 16</span>
      </div>
      <div className="h-16 w-[1px] bg-gray-200 hidden sm:block"></div>
      <h3 className="text-xl font-serif font-bold text-[#221f1f] hidden md:block uppercase tracking-tight">
        Join our community <br/> to help children
      </h3>
    </div>
    
    <button 
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="mt-6 sm:mt-0 border border-[#221f1f] text-[#221f1f] px-10 py-3 font-bold uppercase tracking-widest hover:bg-[#f9b50b] hover:border-[#f9b50b] hover:text-white transition-all duration-300 text-xs"
    >
      Join Now
    </button>
  </div>

  {/* 2. Main Title & Description */}
  <div className="space-y-6">
    <h2 className="text-3xl font-serif font-bold uppercase tracking-tight text-[#221f1f] leading-tight">
      Homeless Poor Children Want To Happy Event
    </h2>
    <div className="h-1 w-16 bg-[#f9b50b]"></div>
    <p className="text-gray-500 leading-relaxed text-[15px]">
      There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing.
    </p>
    
    {/* Fixed Image Container: No awkward cropping */}
    <div className="w-full shadow-sm">
      <img 
        src="/2.jpg" 
        alt="Event Detail" 
        className="w-full h-auto max-h-[500px] object-contain bg-gray-50 rounded-sm" 
      />
    </div>
  </div>

  {/* 3. Info Grid (Tight spacing for details) */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-16 pt-10 border-t border-gray-100">
    {/* Map Section */}
    <div className="space-y-6">
      <h4 className="text-[13px] font-bold uppercase tracking-[0.2em] flex items-center gap-3">
        Map <span className="h-[1px] w-12 bg-[#f9b50b]"></span>
      </h4>
      <div className="w-full h-64 grayscale border border-gray-100 hover:grayscale-0 transition-all duration-700">
        <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.9024424301385!2d90.3910!3d23.7509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDQ1JzAzLjIiTiA5MMKwMjMnMjcuNiJF!5e0!3m2!1sen!2sbd!4v1625000000000!5m2!1sen!2sbd" className="w-full h-full border-0" allowFullScreen="" loading="lazy"></iframe>
      </div>
      <button 
        onClick={() => window.history.back()} 
        className="text-[11px] font-bold uppercase tracking-widest text-[#221f1f] border-b-2 border-[#f9b50b] pb-1 hover:text-[#f9b50b] transition-all"
      >
        Back to Event
      </button>
    </div>

    {/* Event Details Section (Content kept close together) */}
    <div className="space-y-10">
      <div className="space-y-6">
        <h4 className="text-[13px] font-bold uppercase tracking-[0.2em] flex items-center gap-3">
          Event Time <span className="h-[1px] w-12 bg-[#f9b50b]"></span>
        </h4>
        <div className="space-y-3">
          {/* Using flex-start so content stays together */}
          <p className="text-sm flex items-start gap-2">
            <strong className="min-w-[60px] text-[#221f1f]">Start</strong> 
            <span className="text-gray-500">: 25 February 2016 9am</span>
          </p>
          <p className="text-sm flex items-start gap-2">
            <strong className="min-w-[60px] text-[#221f1f]">End</strong> 
            <span className="text-gray-500">: 26 February 2016 5pm</span>
          </p>
          <p className="text-sm flex items-start gap-2">
            <strong className="min-w-[60px] text-[#221f1f]">Set</strong> 
            <span className="text-gray-500">: 57</span>
          </p>
          <p className="text-sm flex items-start gap-2">
            <strong className="min-w-[60px] text-[#221f1f]">Status</strong> 
            <span className="text-[#f9b50b] font-bold">: Free Event</span>
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <h4 className="text-[13px] font-bold uppercase tracking-[0.2em] flex items-center gap-3">
          Location <span className="h-[1px] w-12 bg-[#f9b50b]"></span>
        </h4>
        <p className="text-sm text-gray-500 leading-relaxed italic">
          10012 Dhaka Street, Gazipur , <br/> MR South Island, Bangladesh
        </p>
      </div>
    </div>
  </div>
</div>

          {/* RIGHT: SIDEBAR */}
          <div className="space-y-12">
            
            {/* INTERACTIVE DONATION SLIDER */}
            <div className="relative group overflow-hidden">
              <img src="/events2.jpg" alt="Cause" className="w-full h-[450px] object-cover" />
              
              {/* Overlay Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-12 px-6">
                
                {/* Right/Left Navigation Buttons */}
                <div className="absolute top-1/2 w-full flex justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button onClick={prevSlide} className="bg-[#f9b50b] hover:bg-[#221f1f] text-white p-3 transition-colors">
                    <FaChevronLeft size={14} />
                  </button>
                  <button onClick={nextSlide} className="bg-[#f9b50b] hover:bg-[#221f1f] text-white p-3 transition-colors">
                    <FaChevronRight size={14} />
                  </button>
                </div>

                {/* Sliding Box */}
                <div className="bg-[#221f1f]/90 w-full p-8 text-center text-white">
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={currentSlide}
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.4 }}
                    >
                      <h4 className="font-serif font-bold text-lg uppercase tracking-wider">{sliderData[currentSlide].title}</h4>
                      <p className="italic text-gray-400 text-sm mt-2 mb-6">{sliderData[currentSlide].desc}</p>
                      
                      <div className="mb-6">
                         <span className="text-[#f9b50b] text-2xl font-bold">{sliderData[currentSlide].raised}</span>
                         <span className="text-xs text-gray-300 ml-2 uppercase">Need {sliderData[currentSlide].goal}</span>
                      </div>

                      <button onClick={() => setIsModelOpen(true)} className="border border-[#f9b50b] text-[#f9b50b] font-bold uppercase py-2 px-8 text-xs tracking-widest hover:bg-white hover:text-[#221f1f] transition-all">
                        Donate 
                        </button>
                    </motion.div>
                  </AnimatePresence>
                </div>
              </div>
              <DonationModel 
            isOpen={isModelOpen} 
            onClose={() => setIsModelOpen(false)} 
            causeTitle={sliderData[currentSlide].title} 
              />
            </div>

            {/* CAUSE CATEGORIES */}
            <div className="bg-[#fcfcfc] p-8 border border-gray-100">
              <h4 className="text-lg font-serif font-bold uppercase mb-6 text-[#221f1f]">Cause Categories</h4>
              <ul className="space-y-4">
                {categories.map((cat) => (
                  <li key={cat}>
                    <button 
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      className="flex items-center gap-3 text-sm text-gray-500 hover:text-[#f9b50b] transition-colors group w-full text-left"
                    >
                      <FaThumbsUp className="text-xs text-gray-300 group-hover:text-[#f9b50b]" />
                      {cat}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* HOW YOU WILL HELP US SECTION */}
              <div className="relative overflow-hidden group">
                {/* Image with brightness and hover zoom effect */}
                <img 
                  src="/events1.jpg" 
                  alt="Help Us" 
                  className="w-full h-[450px] object-cover brightness-50 group-hover:scale-105 transition-transform duration-700" 
                />
                
                <div className="absolute inset-0 p-10 flex flex-col justify-center">
                  {/* Heading with Yellow accent on 'How' */}
                  <h4 className="text-4xl font-serif font-bold text-white mb-2 leading-tight">
                    <span className="text-[#f9b50b]">How</span> <br /> You will help us
                  </h4>
                  
                  {/* Yellow horizontal bar */}
                  <div className="h-1 w-12 bg-[#f9b50b] my-6"></div>
                  
                  {/* Interactive List */}
                  <ul className="space-y-4">
                    {helpOptions.map((option) => (
                      <li key={option}>
                        <button 
                          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                          className="flex items-center gap-2 text-white text-sm font-medium hover:text-[#f9b50b] transition-colors w-full text-left"
                        >
                          <FaChevronRight className="text-[10px] text-[#f9b50b]" />
                          {option}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            
          </div>
        </div>
      </section>

      {/* Reusable Donation Modal */}
      <DonationModel isOpen={isModelOpen} onClose={() => setIsModelOpen(false)} causeTitle={sliderData[currentSlide].title} />
    </div>
  );
};

export default EventsDetail;